export const disabilityCategories = [
    { label: 'Blood Disorder', id: 'Blood Disorder' },
    { label: 'Cancer', id: 'Cancer' },
    { label: 'Diabetes, thyroid, other endocrine diseases', id: 'Diabetes, thyroid, other endocrine diseases' },
    { label: 'Digestive system condition, Hernia', id: 'Digestive system condition, Hernia' },
    { label: 'Ear condition', id: 'Ear condition' },
    { label: 'Eye condition', id: 'Eye condition' },
    { label: 'Heart condition', id: 'Heart condition' },
    { label: 'Infection', id: 'Infection' },
    { label: 'Kidney, bladder, reproductive organ condition', id: 'Kidney, bladder, reproductive organ condition' },
    { label: 'Lung condition', id: 'Lung condition' },
    { label: 'Mental Health', id: 'Mental Health' },
    { label: 'Muscle, tendon, joint', id: 'Muscle, tendon, joint' },
    { label: 'Nervous system disorder', id: 'Nervous system disorder' },
    { label: 'Pregnancy', id: 'Pregnancy' },
    { label: 'Skin Condition', id: 'Skin Condition' },
    { label: 'Sprains, strains, or fractures', id: 'Sprains, strains, or fractures' },
    { label: 'Rotator cuff surgery', id: 'Rotator cuff surgery' },
    { label: 'Knee or hip replacement', id: 'Knee or hip replacement' },
    { label: 'Bunion surgery', id: 'Bunion surgery' },
    { label: 'Carpal tunnel surgery', id: 'Carpal tunnel surgery' },
    { label: 'Other', id: 'Other' }
];
